import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 5l0 14","key":"svg-0"}],["path",{"d":"M16 9l-4 -4","key":"svg-1"}],["path",{"d":"M8 9l4 -4","key":"svg-2"}]]

/**
 * IconArrowNarrowUp
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctbmFycm93LXVwIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xMiA1bDAgMTQiIC8+CiAgPHBhdGggZD0iTTE2IDlsLTQgLTQiIC8+CiAgPHBhdGggZD0iTTggOWw0IC00IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/arrow-narrow-up
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowNarrowUp = createReactComponent('outline', 'arrow-narrow-up', 'ArrowNarrowUp', __iconNode);

export default IconArrowNarrowUp;